class Component {

    component_class;
    component_selector;
    component_options;

    constructor(component_class, component_selector, component_options = {}) {

        this.component_class = component_class;
        this.component_selector = component_selector;
        this.component_options = component_options;


    }

    registerListeners(){

    }

    afterDocumentChangedEvent()
    {

    }
}